import { Injectable } from '@angular/core';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { NativeLayerService } from './native-layer.service';
const ELEMENTS_TO_SAVE_IN_PREFERENCES = ['cookiesConsentData'];

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  storage = new Map();

  constructor(
    private native: NativeLayerService
  ) {

  }

  getItem(key: string, meta = false) {
    const data = localStorage.getItem(key);

    if (data) {
      this.storage.set(key, JSON.parse(data));

      return meta ? JSON.parse(data) : JSON.parse(data).value;
    }
    return null;
  }

  setItem(key, value, persistent?) {
    const data = value.metadata && value.value ? value : {
      metadata: { timestamp: new Date().getTime() },
      value
    };
    this.storage.set(key, data);
    const stringifyData = JSON.stringify(data);
    localStorage.setItem(key, stringifyData);

    if (!this.native.isNative) {
        return;
    }
    if (persistent) {
        Filesystem.writeFile({
            path: `${key}.json`,
            data: stringifyData,
            directory: Directory.Data,
            encoding: Encoding.UTF8,
        });
    }
  }
  
  removeItem(key, persistent?) {
    this.storage.delete(key);
    localStorage.removeItem(key);

    if (!this.native.isNative) {
        return;
    }
    if (persistent) {
        Filesystem.deleteFile({
            path: `${key}.json`,
            directory: Directory.Data
        });
    }

  }
  async initFromPreferences(elements?) {
    const promises = elements || ELEMENTS_TO_SAVE_IN_PREFERENCES.map(async (preferencesKey) => {
        try {
            const contents = await Filesystem.readFile({
                path: `${preferencesKey}.json`,
                directory: Directory.Data,
                encoding: Encoding.UTF8,
              });
            
            if (!contents.data) {
                return;
            }
            let dataString: string;
            if (typeof contents.data === 'string') {
                dataString = contents.data;
            } else if (contents.data instanceof Blob) {
                dataString = await contents.data.text();
            } else {
                // Si el tipo no es compatible, no hacemos nada
                return;
            }
            this.setItem(preferencesKey, JSON.parse(dataString));
        } catch (e) {
            return;
        }
        
    });

    return Promise.all(promises);
  }
}
